<ng-container *ngIf="_visible">
  <ng-container *ngIf="_purchaseable === 'loading'">
    <button class="w-100 btn btn-dark" disabled>Loading...</button>
  </ng-container>
  <ng-container *ngIf="_purchaseable !== 'loading'">
    <button class="w-100 btn btn-warning" *ngIf="_preorderMessaging">
      {{ _preorderMessaging }}
    </button>

    <ng-container *ngIf="_purchaseable === 'outofstock'">
      <button (click)="popDrawer()" class="w-100 btn btn-lg btn-dark">
        Notify me when back in stock
      </button>
    </ng-container>
    <ng-container *ngIf="_purchaseable === 'add'">
      <button (click)="addToCart()" class="w-100 btn btn-dark">
        {{ _text }}
      </button>

      <a
        *ngIf="
          ['AU', 'INT'].includes(environment.store) &&
          product?.tags?.includes('personalise')
        "
        [routerLink]="['/personaliser-product/' + product.handle]"
        [queryParams]="{
          variantId: _selectedVariant.id
        }"
        class="w-100 mt-2 btn btn-outline-dark"
        >Personalise - Now Free</a
      >
      <a [routerLink]="['/personaliser-product/' + product.handle]">
        <img
          *ngIf="
            ['AU', 'INT'].includes(environment.store) &&
            product?.tags?.includes('personalise')
          "
          class="w-100 h-auto mt-3"
          src="/assets/840x200 Add To Cart Banner.jpg"
        />
      </a>
    </ng-container>

    <div
      *ngIf="_deliveryMessage"
      class="delivery-messaging d-flex gap-3 flex-column mt-4 border-top pt-4"
    >
      <div class="row gx-0">
        <div
          class="col-2 d-flex flex-column justify-content-center align-items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="#000000"
            viewBox="0 0 256 256"
          >
            <path
              d="M255.42,117l-14-35A15.93,15.93,0,0,0,226.58,72H192V64a8,8,0,0,0-8-8H32A16,16,0,0,0,16,72V184a16,16,0,0,0,16,16H49a32,32,0,0,0,62,0h50a32,32,0,0,0,62,0h17a16,16,0,0,0,16-16V120A7.94,7.94,0,0,0,255.42,117ZM192,88h34.58l9.6,24H192ZM32,72H176v64H32ZM80,208a16,16,0,1,1,16-16A16,16,0,0,1,80,208Zm81-24H111a32,32,0,0,0-62,0H32V152H176v12.31A32.11,32.11,0,0,0,161,184Zm31,24a16,16,0,1,1,16-16A16,16,0,0,1,192,208Zm48-24H223a32.06,32.06,0,0,0-31-24V128h48Z"
            ></path>
          </svg>
        </div>
        <div class="col d-flex align-items-center">
          <div>{{ _deliveryMessage.sameDayDispatch }}</div>
        </div>
      </div>

      <div class="row gx-0">
        <div
          class="col-2 d-flex flex-column justify-content-center align-items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="#000000"
            viewBox="0 0 256 256"
          >
            <path
              d="M223.68,66.15,135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,32l80.34,44-29.77,16.3-80.35-44ZM128,120,47.66,76l33.9-18.56,80.34,44ZM40,90l80,43.78v85.79L40,175.82Zm176,85.78h0l-80,43.79V133.82l32-17.51V152a8,8,0,0,0,16,0V107.55L216,90v85.77Z"
            ></path>
          </svg>
        </div>
        <div class="col d-flex align-items-center">
          <div>{{ _deliveryMessage.expressDelivery }}</div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
